import { Tooltip, TooltipProps } from "@mui/material";
import React, { Fragment } from "react";
import { Omit } from "../../types";

interface ItemizedTooltipProps extends Omit<TooltipProps, "title"> {
  header: string;
  items: string[];
}

const ItemizedTooltip = ({ header, items, ...tooltipProps }: ItemizedTooltipProps) => {
  return (
    <Tooltip
      {...tooltipProps}
      PopperProps={{ sx: { "& .MuiTooltip-tooltip": { maxWidth: 700 } } }}
      title={
        items.length ? (
          <Fragment>
            <div>
              <b>{header}</b>
            </div>
            {items.map(item => (
              <div key={item}>{item}</div>
            ))}
          </Fragment>
        ) : (
          ""
        )
      }
    />
  );
};

export default ItemizedTooltip;
